module.exports = __webpack_public_path__ + "img/recent-changes.d889bac8.svg";